import React, { useContext, useEffect, useMemo, useState } from "react";
import { Box, Button, Container, Grid, styled } from "@mui/material";
import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";
import { useRouter } from "../../utils/hooks/useRouter";
import { iframeTracking } from "../../services/analytics/analytic.service";
import { useAppDispatch } from "../../store/hooks";
import { getBranchInfoDirect } from "../../services/api/retail/merchantInfoApi";
import { setBranchInfo } from "../../store/slices/branchSlice";
import {
  IconActiveNext,
  IconCart,
  IconCircleDecorationSmall,
  IconCircleDecorator,
  IconFeatureTag,
  IconHome,
  IconList,
  IconPlayVideo,
  IconSearch,
} from "../Static/Icons/Icon";
import ModalVideoIntro from "../Modal/Retail/ModalVideoIntro";
import imageOnboarding from "../../assets/images/onboarding-web.png";
import { updateSyncStatusOnboard } from "../../services/api/retail/websiteStatusApi";
import { Redirect } from "../../utils/Redirect";

export const OnboardDom = styled("div")({
  width: "100%",
  display: "flex",
  gap: "53px",
  height: "100vh",
  "> div:nth-of-type(1)": {
    flex: 1,
    marginTop: "230px",
    maxWidth: "491px",
    "> div:nth-of-type(1)": {
      position: "relative",
      fontSize: "48px",
      lineHeight: "60px",
      fontWeight: 700,
      color: "#323741",
      letterSpacing: "-0.02em",
      "> span": {
        color: "#0D5DF0",
      },
      "> div:nth-of-type(1)": {
        position: "absolute",
        bottom: "12px",
        lineHeight: 0,
        left: "187px",
      },
    },
    "> div:nth-of-type(2)": {
      marginTop: "47px",
      display: "flex",
      gap: "20px",
      "> div:nth-of-type(1)": {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: "16px 20px",
        gap: "4px",
        border: "1px solid #0070F4",
        color: "#0070F4",
        fontWeight: "700",
        borderRadius: "4px",
        cursor: "pointer",
        height: "56px",
        "> div:nth-of-type(2)": {
          display: "flex",
          alignItems: "center",
        },
      },
      "> .open-mykiot": {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: "16px 20px",
        gap: "4px",
        background: "#28A745",
        borderRadius: "4px",
        fontWeight: "700",
        color: "white",
        cursor: "pointer",
        textDecoration: "none",
        "> div:nth-of-type(2)": {
          display: "flex",
          alignItems: "center",
        },
      },
    },
  },
});
const ImageDom = styled("div")({
  flex: 1,
  marginTop: "290px",
  background: "linear-gradient(180deg, #EDF9FF 0%, #ADE2FF 100%)",
  padding: "120px 20px 43px 20px",
  borderRadius: "20px",
  position: "relative",
  height: "fit-content",
});
const CircleDecorationBig = styled("div")({
  position: "absolute",
  bottom: 0,
  left: 0,
});
const CircleDecorationSmall = styled("div")({
  position: "absolute",
  top: 0,
  left: "237px",
});
const Profit = styled("div")({
  background: "#F2FBFF",
  borderRadius: "12px",
  padding: "8px 12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "start",
  gap: "8px",
  width: "100%",
  marginTop: "8px",
});
const TextProfit = styled("div")({
  "> div:nth-of-type(1)": {
    color: "#001C43",
    fontSize: "14px",
    fontWeight: "700",
    lineHeight: "140%",
    textAlign: "left",
  },
  "> div:nth-of-type(2)": {
    fontSize: "16px",
    fontWeight: "700",
    lineHeight: "140%",
    textAlign: "left",
    marginTop: "4px",
  },
});
export function ItemProfit({
  icon,
  title,
  profitText,
  profitColor,
}: {
  icon: any;
  title: string;
  profitText: string;
  profitColor: string;
}) {
  return (
    <Profit>
      {icon}
      <TextProfit>
        <div>{title}</div>
        <div style={{ color: `${profitColor}` }}>{profitText}</div>
      </TextProfit>
    </Profit>
  );
}

export default function Onboarding() {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const [isOpenVideo, setIsOpenVideo] = useState(false);
  const ssoPreview = useMemo(() => {
    return `${process.env.REACT_APP_ADMIN_URL}/retail/sso?code=${router?.query?.code}&website_url=preview`;
  }, [router?.query?.code]);

  const handActiveWebsite = () => {
    // changeStatus && changeStatus(1);

    const auth_code = router.query.code?.toString();

    const jwtDecode: { [key: string]: any } = auth_code
      ? jwt_decode(auth_code)
      : {};

    if (auth_code) {
      Cookies.set("mykiot_auth_code", auth_code);
    }

    iframeTracking(router.query.platform, "kv_mk_setup_enable", {
      id: jwtDecode.sub || null,
      merchantId: jwtDecode.kvrid || null,
      merchantCode: jwtDecode.kvrcode || null,
      userName: jwtDecode.preferred_username || null,
    });
    // handActive && handActive();

    handleGetBranchInfo(jwtDecode);

    //handle set status
    const platform = router.query.platform;
    if (!platform || typeof platform !== "string") {
      return () => {
        Redirect({ to: "/session-expired" });
      };
    }

    updateSyncStatusOnboard({ is_onboarding: true, platform }).then(() => {
      window && (window as any).mykiotPreviewWebsite(ssoPreview);
    });
  };

  /**
   * get branch info direct: before synced completed.
   * @param jwtDecode
   */
  const handleGetBranchInfo = async (jwtDecode: any) => {
    const response = await getBranchInfoDirect({
      platform: String(router.query.platform),
      merchantId: jwtDecode.kvrid,
      merchantCode: jwtDecode.kvrcode,
      branchId: jwtDecode.kvbid,
    });

    const { address, wardName, locationName, contactNumber } =
      response?.data?.data?.branch;
    const { retailerName } = response?.data?.data?.merchant;
    const branch = {
      name: retailerName,
      address: address + ", " + wardName + ", " + locationName,
      phone: contactNumber,
    };

    dispatch(
      setBranchInfo({
        info: branch,
      })
    );
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Container
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        <OnboardDom>
          <div>
            <div>
              Mở cửa hàng Online
              <br />
              <span>Miễn Phí</span>
              <div>
                <IconFeatureTag />
              </div>
            </div>
            <div>
              <div onClick={() => setIsOpenVideo(true)}>
                <div>Video giới thiệu</div>
                <div>
                  <IconPlayVideo />
                </div>
              </div>
              <a
                className="open-mykiot"
                onClick={handActiveWebsite}
                target="_parent"
                href={ssoPreview}
              >
                <div>Mở cửa hàng ngay</div>
                <div>
                  <IconActiveNext />
                </div>
              </a>
            </div>
          </div>
          <ImageDom>
            <Grid
              container
              spacing={2}
              sx={{ marginTop: "-18px", marginLeft: "-18px" }}
            >
              <Grid
                item
                xs={6}
                sx={{ paddingLeft: "14px", paddingTop: "10px" }}
              >
                <ItemProfit
                  icon={<IconCart />}
                  title={"Cửa hàng online"}
                  profitColor={"#28B44F"}
                  profitText={"Miễn phí 100%"}
                ></ItemProfit>
              </Grid>
              <Grid item xs={6}>
                <ItemProfit
                  icon={<IconHome />}
                  title={"Giao diện cửa hàng"}
                  profitColor={"#0D5DF0"}
                  profitText={"Đa dạng, đẹp mắt"}
                ></ItemProfit>
              </Grid>
              <Grid item xs={6}>
                <ItemProfit
                  icon={<IconList />}
                  title={"Lên đơn bán hàng"}
                  profitColor={"#0D5DF0"}
                  profitText={"Hiệu quả, tăng doanh thu"}
                ></ItemProfit>
              </Grid>
              <Grid item xs={6}>
                <ItemProfit
                  icon={<IconSearch />}
                  title={"Dễ dàng bán hàng trên"}
                  profitColor={"#0D5DF0"}
                  profitText={"Các kênh online"}
                ></ItemProfit>
              </Grid>
            </Grid>
            <div>
              <img
                src={imageOnboarding}
                width={422}
                style={{
                  position: "absolute",
                  top: "-240px",
                  left: "0",
                  right: "0",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
                alt=""
              />
            </div>
          </ImageDom>
        </OnboardDom>
      </Container>

      <>
        <CircleDecorationBig>
          <IconCircleDecorator />
        </CircleDecorationBig>
        <CircleDecorationSmall>
          <IconCircleDecorationSmall />
        </CircleDecorationSmall>
      </>
      <ModalVideoIntro
        open={isOpenVideo}
        handCancel={() => setIsOpenVideo(false)}
      />
    </Box>
  );
}
